module.exports = __webpack_public_path__ + "static/media/poster-normal-photo.ae14fbc7.png";